import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";

import qs from 'qs';
Vue.prototype.$qs=qs;

import axios from 'axios';
import VueAxios from 'vue-axios';
Vue.use(VueAxios, axios)
axios.defaults.headers.post['Content-type'] = 'application/json'
store.commit('resetState')
axios.defaults.headers['token'] = store.getters.getToken




import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
Vue.use(ElementUI);

Vue.config.productionTip = false;

new Vue({
  router,
  store,
  render: function(h) {
    return h(App);
  }
}).$mount("#app");

// 在main.js或者一个全局的mixin中
 
// 检测是否为移动设备
function isMobileRedirect() {
  // 检查是否是移动设备
  const isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);
 
  // 检查屏幕宽度是否小于768像素（常见的平板电脑或手机分辨率）
  const isMobileScreen = window.screen.width < 768;
 
  // 判断是否是手机端，并执行重定向
  if (isMobile || isMobileScreen) {
    // 这里可以使用window.location.href来进行重定向
    // 例如：window.location.href = 'https://www.example.com/mobile';
    return true;
  }
 
  return false;
}
 
// 在页面加载时调用函数

if (isMobileRedirect()) {
	console.log('手机端自动跳转发生');
	window.location.href="https://app.huangque888.com/m.html";
} else {
	console.log('非手机端');
}
